import type { InjectionKey } from 'vue'
import type ErrorHandler from '@/models/ErrorHandler.ts'
import createServices from '@/services'

export const errorHandlerKey = Symbol() as InjectionKey<ErrorHandler>
export const servicesKey = Symbol() as InjectionKey<ReturnType<typeof createServices>>
